<template>
    <div>
        <v-autocomplete
                v-model="valeur"
                :label="label"
                :loading="loading"
                :items="workFlowStore.workFlows"
                item-value="id"
                item-text="name"
                outlined
                dense
                :return-object="returnObject"
                :color="inputColor"
                :background-color="backgroundColor"
                :readonly="readonly"
                :clearable="!readonly"
                @click:clear="clear"
                @change="save"
                :rules="rules"
                hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData";
import {useWorkFlowStore} from "@/stores/Request/WorkFlow";
import axios from "axios";

export default {
    name: "StrWorkFlowAutocomplete",
    props: {
        value: [Number, Object],
        label: String,
        readonly: Boolean,
        rules: Array,
        returnObject: Boolean,
    },
    setup(props, {emit}) {
        const {inputColor, backgroundColor, loading} = useSharedData();
        const workFlowStore = useWorkFlowStore();

        const valeur = ref(null);


        function findAll() {
            loading.value = true;
            axios.get('/validationWorkFlows').then(response => {
                workFlowStore.setWorkFlows(response.data);
            }).finally(() => {
                loading.value = false;
            })
        }

        function save() {
            emit('input', valeur.value);
        }

        function clear() {
            valeur.value = null;
            emit('input', null);
        }

        watch(() => props.value, () => {
            valeur.value = props.value;
        }, {immediate: true});

        onMounted(() => {
            findAll();
        })

        return {
            inputColor,
            backgroundColor,
            loading,
            valeur,
            workFlowStore,
            save,
            clear,
        }
    }
}
</script>

<style scoped>

</style>